export default defineNuxtRouteMiddleware((_, from) => {
  const appStatusStore = useAppStatusStore();
  appStatusStore.setPreviouslyVisitedPagePath(from.fullPath);
});
